namespace RioERP.Web.Enums {
    export enum PaymentStatus {
        FullyPaid = 1,
        PartiallyPaid = 2,
        Pending = 3,
        Rejected = 4
    }
    Serenity.Decorators.registerEnumType(PaymentStatus, 'RioERP.Web.Enums.PaymentStatus');
}
